import { Permission } from '../interfaces';
import axiosInstance from './axiosConfig';

export async function updateUserPermissions(
  userId: string,
  permissions: Permission[]
) {
  const { data } = await axiosInstance.put(
    `/admin/users/${userId}/permissions`,
    {
      permissions,
    }
  );
  return data;
}
